module.exports = __webpack_public_path__ + "assets/img/soft18.30b22974.jpg";